
const WeeklySchedule = () => {
  const schedule = [
    {
      day: 'Monday',
      sessions: [
        { time: '4:00 PM - 5:00 PM', group: 'Ages 6-8', level: 'Beginner', spots: 12 },
        { time: '5:15 PM - 6:30 PM', group: 'Ages 9-12', level: 'Intermediate', spots: 8 },
        { time: '6:45 PM - 8:00 PM', group: 'Ages 13-16', level: 'Advanced', spots: 5 }
      ]
    },
    {
      day: 'Tuesday',
      sessions: [
        { time: '4:00 PM - 5:00 PM', group: 'Ages 6-8', level: 'Intermediate', spots: 10 },
        { time: '5:15 PM - 6:30 PM', group: 'Ages 9-12', level: 'Advanced', spots: 6 },
        { time: '6:45 PM - 8:00 PM', group: 'Ages 13-16', level: 'Elite', spots: 3 }
      ]
    },
    {
      day: 'Wednesday',
      sessions: [
        { time: '4:00 PM - 5:00 PM', group: 'Ages 6-8', level: 'Beginner', spots: 15 },
        { time: '5:15 PM - 6:30 PM', group: 'Ages 9-12', level: 'Intermediate', spots: 9 },
        { time: '6:45 PM - 8:00 PM', group: 'Ages 13-16', level: 'Advanced', spots: 7 }
      ]
    },
    {
      day: 'Thursday',
      sessions: [
        { time: '4:00 PM - 5:00 PM', group: 'Ages 6-8', level: 'Intermediate', spots: 11 },
        { time: '5:15 PM - 6:30 PM', group: 'Ages 9-12', level: 'Advanced', spots: 4 },
        { time: '6:45 PM - 8:00 PM', group: 'Ages 13-16', level: 'Elite', spots: 2 }
      ]
    },
    {
      day: 'Friday',
      sessions: [
        { time: '4:00 PM - 5:00 PM', group: 'Ages 6-8', level: 'Fun Skills', spots: 18 },
        { time: '5:15 PM - 6:30 PM', group: 'Ages 9-12', level: 'Game Play', spots: 12 },
        { time: '6:45 PM - 8:00 PM', group: 'Ages 13-16', level: 'Competitive', spots: 8 }
      ]
    },
    {
      day: 'Saturday',
      sessions: [
        { time: '9:00 AM - 10:00 AM', group: 'Ages 3-5', level: 'Little Kickers', spots: 20 },
        { time: '10:15 AM - 11:30 AM', group: 'Ages 6-9', level: 'Weekend Warriors', spots: 16 },
        { time: '11:45 AM - 1:00 PM', group: 'Ages 10-13', level: 'Saturday Select', spots: 10 },
        { time: '1:15 PM - 2:30 PM', group: 'Ages 15-18', level: 'Elite Training', spots: 6 }
      ]
    },
    {
      day: 'Sunday',
      sessions: [
        { time: '10:00 AM - 11:00 AM', group: 'Ages 5-8', level: 'Family Fun', spots: 25 },
        { time: '11:15 AM - 12:30 PM', group: 'Ages 9-13', level: 'Sunday Skills', spots: 14 },
        { time: '12:45 PM - 2:00 PM', group: 'Ages 14-17', level: 'Advanced Play', spots: 8 }
      ]
    }
  ];

  const getLevelColor = (level: string) => {
    switch (level) {
      case 'Beginner':
      case 'Little Kickers':
      case 'Fun Skills':
      case 'Family Fun':
        return 'bg-green-100 text-green-800';
      case 'Intermediate':
      case 'Weekend Warriors':
      case 'Sunday Skills':
        return 'bg-blue-100 text-blue-800';
      case 'Advanced':
      case 'Saturday Select':
      case 'Advanced Play':
        return 'bg-purple-100 text-purple-800';
      case 'Elite':
      case 'Elite Training':
      case 'Competitive':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getAvailabilityColor = (spots: number) => {
    if (spots >= 10) return 'text-green-600';
    if (spots >= 5) return 'text-yellow-600';
    return 'text-red-600';
  };

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Weekly Training Schedule</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our comprehensive weekly schedule offers multiple sessions for every age group and skill level. Choose the times that work best for your family.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-8">
          {schedule.map((day) => (
            <div key={day.day} className="bg-white rounded-xl shadow-lg overflow-hidden">
              <div className="bg-gradient-to-r from-blue-600 to-purple-600 px-6 py-4">
                <h3 className="text-xl font-bold text-white">{day.day}</h3>
              </div>
              <div className="p-6 space-y-4">
                {day.sessions.map((session, index) => (
                  <div key={index} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
                    <div className="flex justify-between items-start mb-2">
                      <div className="font-semibold text-gray-900">{session.time}</div>
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${getAvailabilityColor(session.spots)}`}>
                        {session.spots} spots left
                      </span>
                    </div>
                    <div className="text-sm text-gray-600 mb-2">{session.group}</div>
                    <span className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${getLevelColor(session.level)}`}>
                      {session.level}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-blue-50 rounded-xl p-8">
          <div className="text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Schedule Notes</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 text-sm">
              <div className="flex items-center justify-center space-x-2">
                <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                <span>10+ spots available</span>
              </div>
              <div className="flex items-center justify-center space-x-2">
                <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
                <span>5-9 spots available</span>
              </div>
              <div className="flex items-center justify-center space-x-2">
                <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                <span>1-4 spots available</span>
              </div>
              <div className="flex items-center justify-center space-x-2">
                <i className="ri-information-line text-blue-600"></i>
                <span>Sessions subject to weather</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WeeklySchedule;
